import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { MomentModule } from 'ngx-moment';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { MessagesModule } from 'primeng/messages';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule } from '@ngx-translate/core';
import { InputNumberModule } from 'primeng/inputnumber';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ReactiveValidationModule } from 'angular-reactive-validation';

import { LineBreaksPipe, TransportModeIconPipe, UserInfoTooltipComponent } from '@qwyk/ui-standalone';

import {
    OfferLinesRowComponent,
    OfferLinesTableComponent,
    QuotationOfferCopyComponent,
    QuotationsOfferEditComponent,
    QuotationsOfferFormComponent,
    QuotationOfferCreateComponent,
    QuotationsOffersListComponent,
    QuotationsOfferListItemComponent,
    QuotationOfferListExpansionItemComponent,
} from './components';
import { QuotationOffersFacade } from './+state/quotation-offers.facade';
import * as fromQuotationOffers from './+state/quotation-offers.reducer';
import { QuotationOffersEffects } from './+state/quotation-offers.effects';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TableModule,
        MomentModule,
        RouterModule,
        TooltipModule,
        DropdownModule,
        CalendarModule,
        LineBreaksPipe,
        MessagesModule,
        InputTextModule,
        TranslateModule,
        InputNumberModule,
        FontAwesomeModule,
        AutoCompleteModule,
        OverlayPanelModule,
        ReactiveFormsModule,
        InputTextareaModule,
        TransportModeIconPipe,
        ReactiveValidationModule,
        UserInfoTooltipComponent,
        StoreModule.forFeature(
            fromQuotationOffers.QUOTATIONOFFERS_FEATURE_KEY,
            fromQuotationOffers.reducer
        ),
        EffectsModule.forFeature([QuotationOffersEffects]),
    ],
    declarations: [
        OfferLinesRowComponent,
        OfferLinesTableComponent,
        QuotationOfferCopyComponent,
        QuotationsOfferFormComponent,
        QuotationsOfferEditComponent,
        QuotationsOffersListComponent,
        QuotationOfferCreateComponent,
        QuotationsOfferListItemComponent,
        QuotationOfferListExpansionItemComponent,
    ],
    providers: [QuotationOffersFacade],
    exports: [QuotationsOffersListComponent],
})
export class HubQuotationsOffersWithoutRoutingModule {}
